import { createFileRoute, redirect } from "@tanstack/react-router";

/** /en/panel has no page of its own: 301 to the EN home. */
export const Route = createFileRoute("/en/panel/")({
  beforeLoad: () => {
    throw redirect({ to: "/en", statusCode: 301 });
  },
});
